import { asClass } from "awilix";
import { DIContainerKeys } from "../di-container/di-container.keys";
import { AuthService } from "./auth-service/auth-user.service";
import { MspInviteService } from "./msp-invite/msp-invite.service";
import { MspDetailsService } from "./msp-details/msp-details.service";
import { CountriesService } from "./countries/countries.service";
import { PortlandReportService } from "./portland-report/portland-report.service";
import { NetworkAccessService } from "./network-access/network-access.service";
import { ProductService } from "./product/product.service";
import { MembersAccessService } from "./members-access/members-access.service";
import { ColorPaletteService } from "./color-palette/color-palette.service";
import { TagsService } from "./tags/tags.service";
import { EmailTemplatesService } from "./email-templates/email-templates.service";
import { PlanService } from "./plan/plan.service";
import { MemberDetailsService } from "./member-details/member-details.service";
import { AccessRolesDetailsService } from "./access-roles-details/access-roles-details.service";
import { ClientAccessRolesDetailsService } from "./client-access-roles-details/client-access-roles-details.service";
import { CompanySettingsService } from "./company-settings/company-settings.service";
import { ToolService } from "./security-stack-view/tool.service";
import { ToolInfoService } from "./security-stack-view/tool-info.service";
import { PracticeService } from "./security-stack-view/practice.service";
import { SecurityStackHeaderViewService } from "./security-stack-view/security-stack-header-view.service";
import { SecurityStackViewService } from "./security-stack-view/security-stack-view.service";
import { TechnologiesByToolService } from "./security-stack-view/technologies-by-tool.service";
import { CategoryProductsService } from "./category-products/category-products.service";
import { StorefrontProductsService } from "./storefront-products/storefront-products.service";
import { CategoryService } from "./category/category.service";
import { CategorySortOrderService } from "./category-sort-order/category-sort-order.service";
import { SuppliersAndManufacturersService } from "./suppliers-and-manufacturers/suppliers-and-manufacturers.service";
import { RecalculateScoreService } from "./recalculate-score/recalculate-score.service";
import { SubscriptionService } from "./subscription/subscription.service";

export interface IServiceContainer {
  [DIContainerKeys.AuthService]: AuthService;
  [DIContainerKeys.MspInviteService]: MspInviteService;
  [DIContainerKeys.MspDetailsService]: MspDetailsService;
  [DIContainerKeys.CountriesService]: CountriesService;
  [DIContainerKeys.PortlandReportService]: PortlandReportService;
  [DIContainerKeys.NetworkAccessService]: NetworkAccessService;
  [DIContainerKeys.ProductService]: ProductService;
  [DIContainerKeys.MembersAccessService]: MembersAccessService;
  [DIContainerKeys.ColorPaletteService]: ColorPaletteService;
  [DIContainerKeys.TagsService]: TagsService;
  [DIContainerKeys.EmailTemplatesService]: EmailTemplatesService;
  [DIContainerKeys.PlanService]: PlanService;
  [DIContainerKeys.MemberDetailsService]: MemberDetailsService;
  [DIContainerKeys.AccessRolesDetailsService]: AccessRolesDetailsService;
  [DIContainerKeys.ClientAccessRolesDetailsService]: ClientAccessRolesDetailsService;
  [DIContainerKeys.CompanySettingsService]: CompanySettingsService;
  [DIContainerKeys.ToolInfoService]: ToolInfoService;
  [DIContainerKeys.PracticeService]: PracticeService;
  [DIContainerKeys.SecurityStackHeaderViewService]: SecurityStackHeaderViewService;
  [DIContainerKeys.SecurityStackViewService]: SecurityStackViewService;
  [DIContainerKeys.TechnologiesByToolService]: TechnologiesByToolService;
  [DIContainerKeys.ToolService]: ToolService;
  [DIContainerKeys.CategoryProductsService]: CategoryProductsService;
  [DIContainerKeys.StorefrontProductsService]: StorefrontProductsService;
  [DIContainerKeys.CategoryService]: CategoryService;
  [DIContainerKeys.CategorySortOrderService]: CategorySortOrderService;
  [DIContainerKeys.SuppliersAndManufacturersService]: SuppliersAndManufacturersService;
  [DIContainerKeys.RecalculateScoreService]: RecalculateScoreService;
  [DIContainerKeys.SubscriptionService]: SubscriptionService;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [DIContainerKeys.AuthService]: asClass(AuthService).singleton(),
  [DIContainerKeys.MspInviteService]: asClass(MspInviteService).singleton(),
  [DIContainerKeys.MspDetailsService]: asClass(MspDetailsService).singleton(),
  [DIContainerKeys.CountriesService]: asClass(CountriesService).singleton(),
  [DIContainerKeys.PortlandReportService]: asClass(PortlandReportService).singleton(),
  [DIContainerKeys.NetworkAccessService]: asClass(NetworkAccessService).singleton(),
  [DIContainerKeys.ProductService]: asClass(ProductService).singleton(),
  [DIContainerKeys.MembersAccessService]: asClass(MembersAccessService).singleton(),
  [DIContainerKeys.ColorPaletteService]: asClass(ColorPaletteService).singleton(),
  [DIContainerKeys.TagsService]: asClass(TagsService).singleton(),
  [DIContainerKeys.EmailTemplatesService]: asClass(EmailTemplatesService).singleton(),
  [DIContainerKeys.PlanService]: asClass(PlanService).singleton(),
  [DIContainerKeys.MemberDetailsService]: asClass(MemberDetailsService).singleton(),
  [DIContainerKeys.AccessRolesDetailsService]: asClass(AccessRolesDetailsService).singleton(),
  [DIContainerKeys.ClientAccessRolesDetailsService]: asClass(ClientAccessRolesDetailsService).singleton(),
  [DIContainerKeys.CompanySettingsService]: asClass(CompanySettingsService).singleton(),
  [DIContainerKeys.ToolInfoService]: asClass(ToolInfoService).singleton(),
  [DIContainerKeys.PracticeService]: asClass(PracticeService).singleton(),
  [DIContainerKeys.SecurityStackHeaderViewService]: asClass(SecurityStackHeaderViewService).singleton(),
  [DIContainerKeys.SecurityStackViewService]: asClass(SecurityStackViewService).singleton(),
  [DIContainerKeys.TechnologiesByToolService]: asClass(TechnologiesByToolService).singleton(),
  [DIContainerKeys.ToolService]: asClass(ToolService).singleton(),
  [DIContainerKeys.CategoryProductsService]: asClass(CategoryProductsService).singleton(),
  [DIContainerKeys.StorefrontProductsService]: asClass(StorefrontProductsService).singleton(),
  [DIContainerKeys.CategoryService]: asClass(CategoryService).singleton(),
  [DIContainerKeys.CategorySortOrderService]: asClass(CategorySortOrderService).singleton(),
  [DIContainerKeys.SuppliersAndManufacturersService]: asClass(SuppliersAndManufacturersService).singleton(),
  [DIContainerKeys.RecalculateScoreService]: asClass(RecalculateScoreService).singleton(),
  [DIContainerKeys.SubscriptionService]: asClass(SubscriptionService).singleton(),
  };
